/**
 * @file: util.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { StatusColors } from '@euler/components/Colors';
import { InspectionTaskJobStatus } from '@euler/model/enum';

export function getConstructionReportItemStatusInfo(
  status: InspectionTaskJobStatus | undefined,
) {
  if (status == null || status === InspectionTaskJobStatus.Finished) {
    return {
      color: StatusColors.Success,
      text: '已完成',
    };
  }
  if (status === InspectionTaskJobStatus.InProgress) {
    return {
      color: StatusColors.Warn,
      text: '施工中',
    };
  }
  return {
    color: StatusColors.Notice,
    text: '已派工',
  };
}
